// import broadcast_mix from '@/mixins/broadcast_mix'
// mixins:[broadcast_mix('strategy_channel')],

const broadcast_mix = {
  data() {
    this.bc_channelname = ''
    this.bc = null
    this.bc_notSupported = false
    return {}
  },
  beforeUnmount() {
    if (this.bc) {
      this.bc.close()
    }
  },
  methods: {
    bc_initialize() {
      if (!this.bc_channelname) return
      if ('BroadcastChannel' in window) {
        this.bc = new BroadcastChannel(this.bc_channelname)
        this.bc.onmessage = this.bc_handleMessage
      } else {
        this.bc_notSupported = true
      }
    },
    bc_handleMessage(message) {
      console.log(message)
    },
    bc_postMessage(data) {
      if (this.bc) {
        // console.log('message-sent', data, Date.now())
        this.bc.postMessage({
          origin: this.$options.name,
          data,
        })
      }
    },
  },
}

export default broadcast_mix
